import Text from 'components/atomic/atoms/text'

const SharedInlineCode = props => (
  <Text
    {...props}
    as="code"
    size="sm"
    css={{
      bgc: '$bg2',
      px: '$1',
      py: '$0-5',
      border: '1px solid $bg3',
      borderRadius: '$sm',
      ...props.css,
    }}
  />
)

export default SharedInlineCode
